const selectAll = 'Select all that apply';
const overallAccount = 'Overall:';
const overallAmount = 'Overall:';
const movingAccount = 'Moving:';
const movingAmount = 'Moving:';
const hwAccount = 'HW:';
const hwAmount = 'HW:';
const howMuch = 'Amount:';
const howMuchSaved = 'Saved:';
const whenYouNeed = 'When:';
const amountToBorrow = 'How much do you need?';
const amountSaved = 'How much have you saved';
const access = 'Access:';
const next = 'Next';
const goBack = 'Back';
const weekly = 'Weekly';
const quarterly = 'Quarterly';
const monthly = 'Monthly';
const yearly = 'Yearly';
const yearlyPlus = '> Year';
const loanTiming = 'When do you need the money?';
const upFront = 'One lump sum';
const overTime = 'Repeatable access over time';
const moneyTiming = 'How do you need the money?';


export default {
  /**
   * ============================
   * GENERAL MESSAGES
   * ============================
   */
  'nav.prev': goBack,
  'nav.next': next,

  'summary.back': 'Back to Guide',
  'summary.yourAnswers': 'Your Survey Answers',

  'shareViaEmail.title': 'Email Your Recommendations',
  'shareViaEmail.label': 'Enter your email address:',
  'shareViaEmail.button': 'Send',

  'completeGuide.reviewProducts.info': 'Review your list selected products below and make sure that you did not forget to add any items:',
  'completeGuide.reviewProducts': 'Selected Products',
  'completeGuide.submitForm': 'Complete The Conversation',
  'completeGuide.submitForm.info': 'Fill out the fields below with your information and submit the form:',
  'completeGuide.noProductsInCart': 'Your cart is empty.',

  'pleaseSelect' : 'Please Select',

  'landing.title': 'Welcome to the party, my friend.',
  'landing.message': 'Please tell us more about you so that we can deliver the best recommendations to help you achieve your goals.',
  'landing.getStarted': 'Let\'s get started',

  'products.disclosures': 'Disclosures',
  'product.learnMore': 'Learn More',

  'footer.copyright': 'Hancock Whitney Bank, Member FDIC and Equal Housing Lender',
  'footer.copyrightTwo': 'All loans and accounts subject to credit approval. Terms and conditions apply.',

  'contactFormSubmitted.success.title': 'Form submitted',
  'contactFormSubmitted.success.message': 'Your conversation and product recommendations have successfully been sent.',

  'surveyPage.meta.title.entry.productTypePreference': 'Select Assistance Needed Hancock Whitney Client Guide',
  'surveyPage.meta.title.entry.customerReferral': 'Select Referral Methods Hancock Whitney Client Guide',
  'surveyPage.meta.title.entry.isCustomer': 'Select Current Client Type Hancock Whitney Client Guide',
  'surveyPage.meta.title.deposit.wantAccountFeature': 'Select Account Features Hancock Whitney Client Guide',
  'surveyPage.meta.title.deposit.paymentMethods': 'Select Expense Payment Methods Hancock Whitney Client Guide',
  'surveyPage.meta.title.deposit.accounts': 'Enter Deposit Balances Hancock Whitney Client Guide',
  'surveyPage.meta.title.depositNotMinor.savingsGoals': 'Select Savings Goals Hancock Whitney Client Guide',
  'surveyPage.meta.title.deposit.creditCardRewards': 'Select Credit Card Features Hancock Whitney Client Guide',
  'surveyPage.meta.title.deposit.creditCardOptions': 'Select Credit Card Features Hancock Whitney Client Guide ',
  'surveyPage.meta.title.overdraft.overdraftServices': 'Video of Overdraft Services Hancock Whitney Client Guide',
  'surveyPage.meta.title.overdraft.overdraftServicesVideo': 'Play Overdraft Services Video Hancock Whitney Client Guide',
  'surveyPage.meta.title.overdraft.overdraftProtectionType': 'Select Overdraft Protection Type Hancock Whitney Client Guide',
  'surveyPage.meta.title.overdraft.standardOverdraftServices': 'Select Insufficient Funds Method Hancock Whitney Client Guide',
  'surveyPage.meta.title.depositNeeds.depositAccountNeeds': 'Want to Review Deposit Needs Hancock Whitney Client Guide',
  'surveyPage.meta.title.bankingNeeds.bankingNeeds': 'Have or Anticipate a Borrowing Need Hancock Whitney Client Guide',
  'surveyPage.meta.title.borrow.homeOwner': 'Own a home Hancock Whitney Client Guide',
  'surveyPage.meta.title.borrow.mortgageEstimate': 'Estimated Current Home Value Hancock Whitney Client Guide',
  'surveyPage.meta.title.borrow.homeOwnerMortgage': 'Have Mortgage on Home Hancock Whitney Client Guide',
  'surveyPage.meta.title.borrow.homeOwnerBalance': 'Balance of Home Mortgage Hancock Whitney Client Guide',
  'surveyPage.meta.title.borrow.homeOwnerState': 'Is Property in Texas Hancock Whitney Client Guide',
  'surveyPage.meta.title.borrow.borrowGoals': 'Select Borrowing Needs Hancock Whitney Client Guide',
  'surveyPage.meta.title.borrow.useHomeEquity': 'Use Home as Collateral Hancock Whitney Client Guide',
  'surveyPage.meta.title.borrow.useCollateral': "Use Home's Equity as Collateral Hancock Whitney Client Guide ",
  'surveyPage.meta.title.reviewDepositPath': "Want to Discuss Deposit Needs Hancock Whitney Client Guide",
  'surveyPage.meta.title.exit.demographics': 'Age & Income Range Hancock Whitney Client Guide',
  'surveyPage.meta.title.exit.demographicsTwo': 'Net Worth & Zip Code Hancock Whitney Client Guide',

  /**
   * ============================
   * COMMON CONSUMER QUESTIONS
   * ============================
   */

  /* ENTRY Question 1.3 */
  'isCustomer': 'What is your current relationship with Hancock Whitney?',
  'isCustomer.subtext': selectAll,
  'isCustomer.personal': 'Personal Client',
  'isCustomer.business': 'Business Client',
  'isCustomer.private': 'Private Wealth Client',

  /* DEPOSIT Question 2.3 (ONLINE) 2.4 (BRANCH) */
  'currentAccountsQuestionGroup': 'Understanding your estimated balances helps to assure that you are receiving the proper accounts and services for your specific financial needs. Please share with us:',
  'currentAccountsQuestionGroup.subtext': selectAll,
  'currentAccountTypes.cardBuilder.addCard': 'Select',
  'currentAccountTypes.cardBuilder.removeCard': '<i class="fa fa-times"></i>',
  'currentAccountTypes.cardBuilder.editCard': '<i class="fa fa-pencil"></i>',
  'currentAccountTypes.cardBuilder.saveCard': 'Save <i class="fa fa-caret-right"></i>',
  'currentAccountTypes': 'Select an account:',
  'details.currentAccountTypes': 'Accounts Selected:',
  'currentAccountTypes.checking': '<img src="/classpath/assets/images/icon-check.svg" alt="credit card icon" /><span>Checking</span>',
  'currentAccountTypes.checking.image': '/classpath/assets/images/icon-check.svg',
  'currentAccountTypes.checking.title': 'Checking',
  'details.currentAccountTypes.checking': 'Checking Account',
  'currentAccountTypes.savings': '<img src="/classpath/assets/images/icon-savings.svg" alt="piggy bank icon" /><span>Savings</span>',
  'currentAccountTypes.savings.image': '/classpath/assets/images/icon-savings.svg',
  'currentAccountTypes.savings.title': 'Savings',
  'details.currentAccountTypes.savings': 'Savings Account',
  'currentAccountTypes.cd': '<img src="/classpath/assets/images/icon-cd.svg" alt="dollars stacked icon" /><span>CD</span>',
  'currentAccountTypes.cd.image': '/classpath/assets/images/icon-cd.svg',
  'currentAccountTypes.cd.title': 'CD',
  'details.currentAccountTypes.cd': 'CD Account',
  'currentAccountTypes.retirement': '<img src="/classpath/assets/images/icon-retirement.svg" alt="pie chart icon" /><span>Retirement</span>',
  'currentAccountTypes.retirement.image': '/classpath/assets/images/icon-retirement.svg',
  'currentAccountTypes.retirement.title': 'Retirement',
  'details.currentAccountTypes.retirement': 'Retirement Account',

  /* DEPOSIT Question 2.4 */
  'savingsGoalsGroup': 'Help us understand your savings goals.  What are you currently saving for?',
  'savingsGoalsGroup.subtext': selectAll,
  'savingsGoalTypes.cardBuilder.addCard': 'Select',
  'savingsGoalTypes.cardBuilder.removeCard': '<i class="fa fa-times"></i>',
  'savingsGoalTypes.cardBuilder.editCard': '<i class="fa fa-pencil"></i>',
  'savingsGoalTypes.cardBuilder.saveCard': 'Save <i class="fa fa-caret-right"></i>',
  'savingsGoalTypes.cardBuilder.modal.title': 'Tell us about your goal:',
  'savingsGoalTypes': 'Select your goal:',

  /* DEPOSIT Question 2.8 */
  'creditCardRewards': 'You should be rewarded for using a credit card for everyday purchases. Which of the following are most important to you?',
  'creditCardRewards.subtext': selectAll,
  'creditCardRewards.cash': 'Cash back',
  'creditCardRewards.fee': 'No annual fee',
  'creditCardRewards.rewards': 'Rewards',
  'creditCardRewards.travel': 'Travel',
  'creditCardRewards.rate': 'A lower rate',
  'creditCardRewards.none': 'None',

  /* DEPOSIT Question 2.9 */
  'creditCardOptions': 'We have credit card options for every need. Which of the following are most important to you?',
  'creditCardOptions.subtext': selectAll,
  'creditCardOptions.cash': 'Cash back',
  'creditCardOptions.fee': 'No annual fee',
  'creditCardOptions.rewards': 'Rewards',
  'creditCardOptions.travel': 'Travel',
  'creditCardOptions.rate': 'A lower rate',
  'creditCardOptions.none': 'None',

  /* OVERDRAFT Question 3.1 */
  'overdraftServices': 'Life can be busy, which means sometimes you can lose sight of your checking balance. Would you like to see a short video about overdraft options to help you manage your account?',
  'overdraftServices.true': 'Yes',
  'overdraftServices.false': 'No',

  /* OVERDRAFT Question 3.1.1 */
  'overdraftServicesVideo': 'Click on link to learn more: <href>https://www.hancockwhitney.com/hubfs/HW-Products-Services-Videos/Hancock%20Whitney%20Overdraft%20Protection%20Services.mp4||Watch Video</href>',

  /* OVERDRAFT Question 3.2 */
  'overdraftProtectionType': 'When it comes to protecting your checking account from overdraft, which of the following are you interested in?',
  'overdraftProtectionType.subtext': selectAll,
  'overdraftProtectionType.line': 'A line of credit',
  'overdraftProtectionType.line.tooltip': 'With Overdraft Protection from a line of credit, money will be transferred to your checking account during nightly batch processing to cover an overdraft balance up to the available credit in the line. The available balance in the line of credit is also combined with the available balance in your checking account giving you more access to funds when using your ATM or debit card throughout the day.',
  'overdraftProtectionType.savings': 'A savings account',
  'overdraftProtectionType.savings.tooltip': 'With Overdraft Protection from a savings account, money will be transferred to your checking account during nightly batch processing to cover an overdraft balance up to the available balance in the savings account. Overdraft Protection from a savings account does not provide additional availability intra-day for your ATM and debit card transactions.',
  'overdraftProtectionType.checking': 'Another checking account',
  'overdraftProtectionType.checking.tooltip': 'With Overdraft Protection from another checking account, money will be transferred to your checking account during nightly batch processing to cover an overdraft balance up to the available balance in the other checking account. Overdraft Protection from another checking account does not provide additional availability intra-day for your ATM and debit card transactions.',
  'overdraftProtectionType.none': 'None of the above',

  /* OVERDRAFT Question 3.3 */
  'standardOverdraftServices': 'You have a choice in how we handle your ATM and Debit Card transactions when there are insufficient available funds in your account. Would you prefer that we:',
  'standardOverdraftServices.true': 'Consider authorizing these transactions into overdraft if there are insufficient funds in the checking account, which may cause overdraft fees.',
  'standardOverdraftServices.false': 'Decline these transactions if sufficient funds are not available.',

  'creditScoreTrack': 'Are you interested in keeping track of your credit score?',
  'creditScoreTrack.tooltip': 'ID Protect® Score Tracker provides valuable insights into your credit score. This service plots your credit score each month, along with score factors that provide insight into which events may have caused your credit to change.',
  'creditScoreTrack.true': 'Yes',
  'creditScoreTrack.false': 'No',

  /* OVERDRAFT Question 3.4 */
  'depositAccountNeeds': 'We have a number of options when it comes to your  deposit account needs. Can we present more information on these now?',
  'depositAccountNeeds.true': 'Yes',
  'depositAccountNeeds.false': 'No, thank you',

  /* OVERDRAFT Question 3.5 */
  'bankingNeeds': 'We have a number of options when it comes to your borrowing needs. Can we present more information on these now?',
  'bankingNeeds.true': 'Yes',
  'bankingNeeds.false': 'No, thank you',

  /* BORROW Question 4.1 */
  'homeOwner': 'Home ownership can help you secure funds for your borrowing needs. Do you currently own your home?',
  'homeOwner.true': 'Yes',
  'homeOwner.false': 'No',

  /* BORROW Question 4.2 */
  'mortgageEstimate': 'What is the estimated current value of your home?',

  /* BORROW Question 4.3 */
  'homeOwnerMortgage': 'Do you currently have a mortgage on your home?',
  'homeOwnerMortgage.true': 'Yes',
  'homeOwnerMortgage.false': 'No',

  /* BORROW Question 4.4 */
  'homeOwnerBalance': 'What is the balance of your current home mortgage?',

  /* BORROW Question 4.5 */
  'homeOwnerState': 'Is this property located in Texas?',
  'homeOwnerState.true': 'Yes',
  'homeOwnerState.false': 'No',

  /* BORROW Question 4.6 */
  'borrowGoalsGroup': 'Help us understand your borrowing needs.',
  'borrowGoalsGroup.subtext': selectAll,
  'borrowGoalsTypes.cardBuilder.addCard': 'Select',
  'borrowGoalsTypes.cardBuilder.removeCard': '<i class="fa fa-times"></i>',
  'borrowGoalsTypes.cardBuilder.editCard': '<i class="fa fa-pencil"></i>',
  'borrowGoalsTypes.cardBuilder.saveCard': 'Save <i class="fa fa-caret-right"></i>',
  'borrowGoalsTypes.cardBuilder.modal.title': 'Tell us about your goal:',
  'borrowGoalsTypes': 'Select your goal:',
  'borrowGoalsTypes.borrowHomeGoal': 'Purchase a Home',
  'borrowGoalsTypes.borrowHomeGoal.icon': '/classpath/assets/images/icon-home.svg',
  'borrowGoalsTypes.borrowHomeGoal.image': '/classpath/assets/images/icon-home.svg',
  'borrowGoalsTypes.borrowHomeGoal.title': 'Purchase a Home',
  'borrowGoalsTypes.borrowSecondHomeGoal': 'Purchase a second home or investment property',
  'borrowGoalsTypes.borrowSecondHomeGoal.icon': '/classpath/assets/images/icon-home.svg',
  'borrowGoalsTypes.borrowSecondHomeGoal.image': '/classpath/assets/images/icon-home.svg',
  'borrowGoalsTypes.borrowSecondHomeGoal.title': 'Purchase a second home',
  'borrowGoalsTypes.borrowVehicleGoal': 'Purchase a Vehicle',
  'borrowGoalsTypes.borrowVehicleGoal.icon': '/classpath/assets/images/icon-vehicle.svg',
  'borrowGoalsTypes.borrowVehicleGoal.image': '/classpath/assets/images/icon-vehicle.svg',
  'borrowGoalsTypes.borrowVehicleGoal.title': 'Purchase a Vehicle',
  'borrowGoalsTypes.borrowLandGoal': 'Purchase land',
  'borrowGoalsTypes.borrowLandGoal.icon': '/classpath/assets/images/icon-landing.svg',
  'borrowGoalsTypes.borrowLandGoal.image': '/classpath/assets/images/icon-landing.svg',
  'borrowGoalsTypes.borrowLandGoal.title': 'Purchase land',
  'borrowGoalsTypes.borrowEducationGoal': 'Borrow for education',
  'borrowGoalsTypes.borrowEducationGoal.icon': '/classpath/assets/images/icon-education.svg',
  'borrowGoalsTypes.borrowEducationGoal.image': '/classpath/assets/images/icon-education.svg',
  'borrowGoalsTypes.borrowEducationGoal.title': 'Borrow for education',
  'borrowGoalsTypes.borrowHomeImprovementGoal': 'Make improvements to my home',
  'borrowGoalsTypes.borrowHomeImprovementGoal.icon': '/classpath/assets/images/icon-homeImprovement.svg',
  'borrowGoalsTypes.borrowHomeImprovementGoal.image': '/classpath/assets/images/icon-homeImprovement.svg',
  'borrowGoalsTypes.borrowHomeImprovementGoal.title': 'Home Improvements',
  'borrowGoalsTypes.borrowDebtConsolidationGoal': 'Consolidate debt',
  'borrowGoalsTypes.borrowDebtConsolidationGoal.icon': '/classpath/assets/images/icon-debt.svg',
  'borrowGoalsTypes.borrowDebtConsolidationGoal.image': '/classpath/assets/images/icon-debt.svg',
  'borrowGoalsTypes.borrowDebtConsolidationGoal.title': 'Consolidate debt',
  'borrowGoalsTypes.borrowOtherGoal': 'Other',
  'borrowGoalsTypes.borrowOtherGoal.icon': '/classpath/assets/images/icon-other.svg',
  'borrowGoalsTypes.borrowOtherGoal.image': '/classpath/assets/images/icon-other.svg',
  'borrowGoalsTypes.borrowOtherGoal.title': 'Other',

  /* BORROW Question 4.6.1 - home */
  'borrowHomeGoal.cardBuilder.title': 'Purchase a home',
  'borrowHomeGoalAmount': 'How much do you need?',
  'details.borrowHomeGoalAmount': `Goals: Purchase a home | ${ amountToBorrow }`,
  'borrowHomeGoalTiming': moneyTiming,
  'borrowHomeGoalTiming.upFront': upFront,
  'borrowHomeGoalTiming.overTime': overTime,
  'details.borrowHomeGoalTiming': `Goals: Purchase a home | ${ loanTiming }`,
  'borrowHomeGoalAmount.cardBuilder.answerLabel': howMuch,
  'borrowHomeGoalTiming.cardBuilder.answerLabel': whenYouNeed,

  /* BORROW Question 4.6.1 - second home */
  'borrowSecondHomeGoal.cardBuilder.title': 'Purchase a second home',
  'borrowSecondHomeGoal.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'borrowSecondHomeGoalAmount': 'How much do you need?',
  'details.borrowSecondHomeGoalAmount': `Goals: Purchase a second home | ${ amountToBorrow }`,
  'borrowSecondHomeGoalTiming': moneyTiming,
  'borrowSecondHomeGoalTiming.upFront': upFront,
  'borrowSecondHomeGoalTiming.overTime': overTime,
  'details.borrowSecondHomeGoalTiming': `Goals: Purchase a second home | ${ loanTiming }`,
  'borrowSecondHomeGoalAmount.cardBuilder.answerLabel': howMuch,
  'borrowSecondHomeGoalTiming.cardBuilder.answerLabel': whenYouNeed,

  /* BORROW Question 4.6.2 - vehicle */
  'borrowVehicleGoal.cardBuilder.title': 'Purchase a vehicle',
  'borrowVehicleGoal.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'borrowVehicleGoalAmount': 'How much do you need?',
  'details.borrowVehicleGoalAmount': `Goals: Purchase a vehicle | ${ amountToBorrow }`,
  'borrowVehicleGoalTiming': moneyTiming,
  'borrowVehicleGoalTiming.upFront': upFront,
  'borrowVehicleGoalTiming.overTime': overTime,
  'details.borrowVehicleGoalTiming': `Goals: Purchase a vehicle | ${ loanTiming }`,
  'borrowVehicleGoalAmount.cardBuilder.answerLabel': howMuch,
  'borrowVehicleGoalTiming.cardBuilder.answerLabel': whenYouNeed,

  /* BORROW Question 4.6.3 - land */
  'borrowLandGoal.cardBuilder.title': 'Purchase land',
  'borrowLandGoal.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'borrowLandGoalAmount': 'How much do you need?',
  'details.borrowLandGoalAmount': `Goals: Purchase land | ${ amountToBorrow }`,
  'borrowLandGoalTiming': moneyTiming,
  'borrowLandGoalTiming.upFront': upFront,
  'borrowLandGoalTiming.overTime': overTime,
  'details.borrowLandGoalTiming': `Goals: Purchase land | ${ loanTiming }`,
  'borrowLandGoalAmount.cardBuilder.answerLabel': howMuch,
  'borrowLandGoalTiming.cardBuilder.answerLabel': whenYouNeed,

  /* BORROW Question 4.6.4 - education */
  'borrowEducationGoal.cardBuilder.title': 'Borrow for education',
  'borrowEducationGoal.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'borrowEducationGoalAmount': 'How much do you need?',
  'details.borrowEducationGoalAmount': `Goals: Borrow for education | ${ amountToBorrow }`,
  'borrowEducationGoalTiming': moneyTiming,
  'borrowEducationGoalTiming.upFront': upFront,
  'borrowEducationGoalTiming.overTime': overTime,
  'details.borrowEducationGoalTiming': `Goals: Borrow for education | ${ loanTiming }`,
  'borrowEducationGoalAmount.cardBuilder.answerLabel': howMuch,
  'borrowEducationGoalTiming.cardBuilder.answerLabel': whenYouNeed,

  /* BORROW Question 4.6.5 - home improvement */
  'borrowHomeImprovementGoal.cardBuilder.title': 'Make improvements to my home',
  'borrowHomeImprovementGoal.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'borrowHomeImprovementGoalAmount': 'How much do you need?',
  'details.borrowHomeImprovementGoalAmount': `Goals: Make improvements to my home | ${ amountToBorrow }`,
  'borrowHomeImprovementGoalTiming': moneyTiming,
  'borrowHomeImprovementGoalTiming.upFront': upFront,
  'borrowHomeImprovementGoalTiming.overTime': overTime,
  'details.borrowHomeImprovementGoalTiming': `Goals: Make improvements to my home | ${ loanTiming }`,
  'borrowHomeImprovementGoalAmount.cardBuilder.answerLabel': howMuch,
  'borrowHomeImprovementGoalTiming.cardBuilder.answerLabel': whenYouNeed,

  /* BORROW Question 4.6.6 - debt consolidation */
  'borrowDebtConsolidationGoal.cardBuilder.title': 'Consolidate debt',
  'borrowDebtConsolidationGoal.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'borrowDebtConsolidationGoalAmount': 'How much do you need?',
  'details.borrowDebtConsolidationGoalAmount': `Goals: Consolidate debt | ${ amountToBorrow }`,
  'borrowDebtConsolidationGoalTiming': moneyTiming,
  'borrowDebtConsolidationGoalTiming.upFront': upFront,
  'borrowDebtConsolidationGoalTiming.overTime': overTime,
  'details.borrowDebtConsolidationGoalTiming': `Goals: Consolidate debt | ${ loanTiming }`,
  'borrowDebtConsolidationGoalAmount.cardBuilder.answerLabel': howMuch,
  'borrowDebtConsolidationGoalTiming.cardBuilder.answerLabel': whenYouNeed,

  /* BORROW Question 4.6.7 - Other */
  'borrowOtherGoal.cardBuilder.title': 'Other',
  'borrowOtherGoal.cardBuilder.body': '<i class="bmo-icon personal-wallet"></i>',
  'borrowOtherGoalAmount': 'How much do you need?',
  'details.borrowOtherGoalAmount': `Goals: Other | ${ amountToBorrow }`,
  'borrowOtherGoalTiming': moneyTiming,
  'borrowOtherGoalTiming.upFront': upFront,
  'borrowOtherGoalTiming.overTime': overTime,
  'details.borrowOtherGoalTiming': `Goals: Other | ${ loanTiming }`,
  'borrowOtherGoalAmount.cardBuilder.answerLabel': howMuch,
  'borrowOtherGoalTiming.cardBuilder.answerLabel': whenYouNeed,

  /* BORROW Question 4.7 */
  'useHomeEquity': 'Congrats!  You have worked hard and have accumulated equity in your home.  Would you consider using your home as collateral for your borrowing needs?',
  'useHomeEquity.tooltip': 'Home equity is the real property’s current market value less any liens (e.g. mortgage) that are attached to that property. For example, if your home’s appraised current market value = $250,000 and the only lien is your mortgage balance of $100,000, then you have approximately $150,000 of home equity because your home is worth more than you owe on it. Your home equity can increase as you pay down your mortgage balance and/or if your property’s value rises. Lenders will allow you to utilize a portion of your home’s verified equity as collateral for a home equity loan or line of credit. Keep in mind that when your home is used as collateral to secure a mortgage or home equity loan/line of credit, if you fail to make monthly payments according to the terms of your loan, your lender has the option to claim ownership of the property due to its security interest.',
  'useHomeEquity.true': 'Yes',
  'useHomeEquity.false': 'No',

  /* BORROW Question 4.8 */
  'useCollateral': 'Would you consider securing your loan with collateral such as another savings account, a CD, or a paid off vehicle? ',
  'useCollateral.auto': 'Yes, an automobile',
  'useCollateral.savings': 'Yes, a CD or savings account',
  'useCollateral.other': 'Yes, something other than an auto or CD / savings account',
  'useCollateral.none': 'None',

  /* DEMOGRAPHICS - asset protection */
  'assetProtection':'Protecting your family, assets, and yourself is a concern Hancock Whitney can assist you with. Do any of the following apply to you?',
  'assetProtection.dependent':'I have someone that is financially dependent on me',
  'assetProtection.lackingLifeInsurance':'I do not have enough life insurance to take care of my family',
  'assetProtection.retired':'I have recently retired',
  'assetProtection.inheritance':'I have recently received an inheritance',
  'assetProtection.annuity':'I have an existing annuity',
  'assetProtection.cashLifeInsurance':'I have cash value life insurance',
  'assetProtection.none':'None of the above',

  'financialHardship':"We'd like the opportunity to help protect you from financial hardship. Let us know if any of the following apply to you.",
  'financialHardship.subtext': selectAll,
  'financialHardship.dependent':'I have someone that is financially dependent on me',
  'financialHardship.lackingLifeInsurance':'I do not have enough life insurance to take care of my family',
  'financialHardship.retired':"I'm retiring soon and will have a change in my group benefits",
  'financialHardship.inheritance':'I have recently received an inheritance',
  'financialHardship.reviewLifeInsurance':'I have an existing life insurance policy that should be reviewed',
  'financialHardship.heirs':'I intend to leave a portion of my assets to my heirs',
  'financialHardship.noPlan':'I do not have a plan in place for an extended care event',
  'financialHardship.none':'None of the above',

  'insuranceReview':'Based on your previous answers, we suggest that you review your insurance coverage to best fit your needs. Would you like to have someone contact you to review your options?',
  'insuranceReview.true':'Yes',
  'insuranceReview.false':'No',

    /* DEMOGRAPHICS Question 4.13 */
  'customerAge': "What is your age?",
  'customerAge.tooltip': "Minimum legal age to open lending accounts varies by state (AL minimum = 19 years old, other states = 18 years old)",
  'customerAge.details': "<h4>What is your age?</h4>",
  'customerAge.definition': "Enter your age",
  'customerAge.input.placeholder': "Enter your age",

  /* DEMOGRAPHICS Question 4.16 */
  'annualIncome': "What is your annual household income?",
  'annualIncome.12500': "Less than $25,000",
  'annualIncome.32500': "$25,000 to $34,999",
  'annualIncome.40000': "$35,000 to $49,999",
  'annualIncome.57500': "$50,000 to $59,999",
  'annualIncome.67500': "$60,000 to $74,999",
  'annualIncome.87500': "$75,000 to $99,999",
  'annualIncome.112500': "$100,000 to $124,999",
  'annualIncome.137500': "$125,000 to $149,999",
  'annualIncome.175000': "$150,000 to $249,999",
  'annualIncome.250000': "$250,000 to $349,999",
  'annualIncome.350000': "$350,000 and up",

  /* DEMOGRAPHICS Question 4.17 */
  'customerNetWorth': 'Investable Assets greater than $1,000,000',
  'customerNetWorth.subtext': '*Investable Assets excludes qualified retirement plans unless the client is retiring within 12 months and Hancock Whitney has the opportunity to manage those assets. Additionally, self-directed IRA’s can be considered.',
  'customerNetWorth.true': 'Yes',
  'customerNetWorth.false': 'No',

  /* DEMOGRAPHICS Question 4.18 */
  'postalCode': "What is your home zip code?",
  'postalCode.subtext': "We currently serve communities located near Hancock Whitney branch locations in the states of AL, FL, LA, MS and TX",
  'postalCode.definition': "Enter zip code",
  'postalCode.input.placeholder': "Enter your zip code (i.e. 75254)",

  /* Question 1.5.1 */
  'consumerState': "State",
  'consumerState.definition': "State",

  'savingsGoalTypes.savingsHolidayGoal': 'Holiday Expenses',
  'savingsGoalTypes.savingsHolidayGoal.image': '/classpath/assets/images/icon-holiday.svg',
  'savingsGoalTypes.savingsHolidayGoal.title': 'Holiday Expenses',
  'savingsGoalTypes.savingsMajorGoal': 'Major Purchase',
  'savingsGoalTypes.savingsMajorGoal.image': '/classpath/assets/images/icon-majorPurchase.svg',
  'savingsGoalTypes.savingsMajorGoal.title': 'Major Purchase',
  'savingsGoalTypes.savingsRetirementGoal': 'Retirement',
  'savingsGoalTypes.savingsRetirementGoal.image': '/classpath/assets/images/icon-retirement.svg',
  'savingsGoalTypes.savingsRetirementGoal.title': 'Retirement',
  'savingsGoalTypes.savingsUnexpectedGoal': 'Unexpected Expense',
  'savingsGoalTypes.savingsUnexpectedGoal.image': '/classpath/assets/images/icon-unexpected.svg',
  'savingsGoalTypes.savingsUnexpectedGoal.title': 'Unexpected Expense',
  'savingsGoalTypes.savingsOtherGoal': 'General Savings',
  'savingsGoalTypes.savingsOtherGoal.image': '/classpath/assets/images/icon-savings.svg',
  'savingsGoalTypes.savingsOtherGoal.title': 'General Savings',
};
